import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FormDialog, DataTableColumn, DataType, FormDialogMode } from '@globaleris/ui.library';
import moment from 'moment';
import { mapCalculatePercent } from '../capacity.mapper';

export interface EditAllocationProps {
  itemSelected?: any;
  show?: boolean;
  onCloseForm: (data: any) => void;
}

export const EditAllocation: React.FC<EditAllocationProps> = ({
  itemSelected,
  show = false,
  onCloseForm
}) => {
  const [t] = useTranslation(['capacity', 'enums']);

  enum EnumFields {
    QTY,
    PERCENTAGE
  }

  useEffect(() => {
    if (itemSelected != null) {
      if (moment(itemSelected.date) >= moment()) {
        setNominationDisabled(true);
        itemSelected.daily = 1;
      } else {
        setNominationDisabled(false);
      }
    }
  }, [itemSelected]);

  const [fieldSelected, setFieldSelected] = React.useState<EnumFields | undefined>(EnumFields.QTY);
  const [nominationDisabled, setNominationDisabled] = React.useState<boolean | undefined>(false);

  const handleQuantityFormFieldChange = (value: number) => {
    if (fieldSelected === EnumFields.QTY) {
      itemSelected.percentage = mapCalculatePercent(value / itemSelected.capacityQuantity);
    }
  };
  const handleUsePercentageFormFieldChange = (value: number) => {
    if (fieldSelected === EnumFields.PERCENTAGE) {
      itemSelected.quantity = (itemSelected.capacityQuantity * value) / 100;
    }
  };

  const formEdit: DataTableColumn[] = [
    {
      name: 'quantity',
      label: t('capacity:forms.editAllocation.inputs.quantity'),
      type: DataType.NUMBER,
      onChange: async (data: any) => {
        handleQuantityFormFieldChange(data);
      },
      onFocus: () => {
        setFieldSelected(EnumFields.QTY);
      }
    },
    {
      name: 'percentage',
      label: t('capacity:forms.editAllocation.inputs.percentage'),
      type: DataType.NUMBER,
      onChange: async (data: any) => {
        handleUsePercentageFormFieldChange(data);
      },
      onFocus: () => {
        setFieldSelected(EnumFields.PERCENTAGE);
      }
    },
    {
      name: 'daily',
      label: ' ',
      type: DataType.RADIO,
      selectOptions: [
        { value: 1, label: t('capacity:forms.editAllocation.inputs.dailyNomination') },
        { value: 2, label: t('capacity:forms.editAllocation.inputs.allocateKeepingNomination') }
      ],
      inputSize: 12,
      readOnly: nominationDisabled
    }
  ];

  return (
    <>
      <FormDialog
        inputs={formEdit}
        inputData={itemSelected ? itemSelected : {}}
        title={t('capacity:forms.editAllocation.title', {
          date: moment(itemSelected?.date).format('DD/MM/YYYY')
        })}
        mode={FormDialogMode.EDIT}
        open={show}
        isWaiting={false}
        onClose={onCloseForm}
        okBtnLabel={t('capacity:forms.editAllocation.mainActions.ok')}
        cancelBtnLabel={t('capacity:forms.editAllocation.mainActions.cancel')}
      />
    </>
  );
};
